import React, {Component} from "react"

import {User} from "~/utils/ShelfEntities"
import {handleDestroyError} from "."
import Button from "~/components/Button"
import {withTranslation} from "react-i18next"

const icon = require("~/icons/team_32_blue.svg")
const icon_delete = require("~/icons/action_delete.svg")
const icon_edit = require("~/icons/action_edit.svg")

class ListItemUser extends Component {
  destroyUser() {
    if (window.confirm(this.props.t("users.deleteConfirmation"))) {
      User.destroy(this.props.id)
        .then(() => this.props.update())
        .catch(handleDestroyError)
    }
  }

  render() {
    return (
      <div className="sh-list-item">
        <img src={icon} alt={"User"} />
        <div className={"content"}>
          <div className="primary">{this.props.email}</div>
          <div className="secondary">{this.props.role}</div>
        </div>

        {!this.props.disableUserActions && (
          <div className="actions">
            <Button
              onClick={this.destroyUser.bind(this)}
              icon={icon_delete}
              label={this.props.t("users.delete")}
            />
            <Button
              to={
                "/tenants/" + this.props.subdomain + "/users/" + this.props.id
              }
              icon={icon_edit}
              label={this.props.t("users.edit")}
            />
          </div>
        )}
      </div>
    )
  }
}

export default withTranslation()(ListItemUser)



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemUser.js